import React, {FC} from 'react';
import {IPricingItem} from '../../types';
import {checkedIconPrice, infinityIcon} from '../../../images/svgIcons';
import './styles.scss';

const PricingItem: FC<IPricingItem> = ({
  isBold,
  text,
  isChecked,
  unlimited,
  number,
  select,
  // selectedValue,
  onChange,
  options,
}) => {
  return (
    <div className="pricing-item">
      {isBold ? (
        <div className="bold-item">{text}</div>
      ) : (
        <div className="d-flex">
          <div className="d-flex align-items-center justify-content-center">
            <div className={`${isChecked || unlimited ? 'icon-wrapper text-center' : 'number-wrapper m-auto'}`}>
              {isChecked ? checkedIconPrice : unlimited ? infinityIcon : number}
            </div>
          </div>
          <div className="text-wrapper ml-2 px-0">
            {/* {select && onChange ? (
              <Select
                options={options}
                value={selectedValue}
                onChange={(val: any) => onChange && onChange(val)}
                className="pricing-item-select"
              />
            ) : (
              text
            )} */}
            {text}
          </div>
        </div>
      )}
    </div>
  );
};

export default PricingItem;
